// extracted by mini-css-extract-plugin
export var user = "User-module--user--17bKf";
export var userPrimary = "User-module--user--primary--d5y4v";